//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { selectRowHeader, setCurrentTable, setParams } from '@/redux/slices/dataTableSlice';
import TableContainer from '@/components/_common/Table/TableContainer';
import JobsTitleBar from './JobsTitleBar';
import { selectJobTypes } from '../../redux/selectors/constantsSelectors';
import DataTableFilters from '../_common/Filters/DataTableFilters';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const Jobs = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const currentTableKey = useAppSelector(selectCurrentTableKey);
  const jobTypes = useAppSelector(selectJobTypes);

  useEffect(() => {
    dispatch(setCurrentTable('jobs'));
    dispatch(setParams({ job_type_filter: Object.keys(jobTypes) }));

    // clean up function to reset the selected rows when the component unmounts
    return () => {
      dispatch(selectRowHeader([]));
    };
  }, []);

  const onRowClick = (e, item) => {
    const url = `/jobs/${item.id}`;
    // TODO: we're doing this to simulate ctrl+click,
    // but we should be using the proper element for accessibility
    e.ctrlKey || e.metaKey ? window.open(url) : history.push(url);
  };

  return (
    <>
      {currentTableKey === 'jobs' && (
        <>
          <JobsTitleBar />
          <DataTableFilters />
          {/* <JobsFilters /> */}
          <TableContainer onRowClick={onRowClick} />
        </>
      )}
    </>
  );
};

export default Jobs;
